import React, {useEffect, useRef, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import {Button, Checkbox, Form, Input, Space, message} from "antd";
import {useIntl} from "react-intl";
import {Buffer} from 'buffer';


import {setInitUrl, updateActiveAgents, updateAgents} from "src/appRedux/actions";
import Logo from "src/assets/svg/Logo";
import {useAuth} from "src/authentication";
import CircularProgress2 from "src/components/CircularProgress2";
import {generateFullyUniqueID, getFormattedClientName, getFormattedDeviceName, getLoginFormData} from "src/util/common";
import IntlMessages from "src/util/IntlMessages";
import { usePopup } from "src/util/use-popup";
import beApis from "src/util/apis/be";

import './index.css'
import { useNavigate } from "react-router-dom";
import AtomicPopup from "../../../components/AtomicPopup";
import Favorites from "../../Home/FavoritesPopup";
import RegisterDevice from "./RegisterDevice";
import {ExclamationCircleOutlined} from "@ant-design/icons";
import ToastError from "../../../assets/svg/ToastError";
import ToastWarn from "../../../assets/svg/ToastWarn";
import WaitingRegister from "./WaitingRegister";
import ToastSuccess from "../../../assets/svg/ToastSuccess";
import FirstLoginPasswordModal from "../../../components/FirstLoginPasswordModal";

const SignIn = (props) => {
  const [form] = Form.useForm();
  const {isLoading, userLogin, userLoginByQuickLink, userSNSLogin, userLoginByApproval} = useAuth();
  const intl = useIntl();
  const [SNSAccessToken, setSNSAccessToken] = useState(undefined);
  const [openRegisterDevicePopup, setOpenRegisterDevicePopup] = useState(false)
  const [openWaitingRegisterPopup, setOpenWaitingRegisterPopup] = useState(false);
  const [disableWaitingCancel, setDisableWaitingCancel] = useState(false);
  const deviceUUID = useRef(undefined);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const csSelected = useSelector(({ cs }) => cs.csSelected);
  const { errorCatchPopup, errorPopup, infoPopup } = usePopup();

  // ✅20250805 - SONG
  const accessModeInfo = useRef(undefined);
  const registerCancel = useRef(false);
  const requestRegisterData = useRef(undefined);
  const [loadingMessage, setLoadingMessage] = useState({
    title: '',
    message: '',
  });
  const approvalCheckHandlerRef = useRef(undefined);

  // ✅ 첫 로그인 비밀번호 변경 관련 state
  const [openFirstLoginModal, setOpenFirstLoginModal] = useState(false);
  const [isChangingPassword, setIsChangingPassword] = useState(false);
  const [currentLoginEmail, setCurrentLoginEmail] = useState('');
  const [currentLoginPassword, setCurrentLoginPassword] = useState('');
  const [firstLoginUserId, setFirstLoginUserId] = useState(null);

  useEffect(() => {
    // TODO: 기존 로그인 사용자 관련 정보 초기화
    dispatch(updateActiveAgents(undefined));
    dispatch(updateAgents(undefined));

    const account = localStorage.getItem("rememberMe");
    deviceUUID.current = localStorage.getItem('device_uuid');
    if (!deviceUUID.current) {
      generateFullyUniqueID().then(uuid => {
        deviceUUID.current = uuid;
        localStorage.setItem('device_uuid', deviceUUID.current);
      });
    }

    if (account) {
      form.setFieldsValue({"rememberMe": true});
      form.setFieldsValue({"email": account});
    }

  }, []);

  useEffect(() => {
    if (SNSAccessToken) {
      userSNSLogin(getLoginFormData({accessToken: SNSAccessToken}));
    }
  }, [SNSAccessToken]);

  // const getLoginFormData = ({email, password, accessToken = null}) => {
  //
  //     const data = {
  //         grant_type: "password",
  //         client_id: '8b38cFmyzu3p1CQYAtfssBrUUMZdPmhPf4SnVjuE',
  //         client_secret: 'pbJcE7IXhU1i0nqeRcoLLtqj8irm9KA11wqSZ7LWpJlM0pkGmq08Ocqu5vw10Y26AeDzoKfwbXgrPBAfUlIQLoBTJ2T1hgUNwqtBXfZfK7XbeHio1a1UYX3bnupk8Sld',
  //     };
  //     const formData = new FormData();
  //     Object.entries(data).forEach(([key, value]) => {
  //         formData.append(key, value);
  //     });
  //
  //     if (accessToken) {
  //         formData.append("access_token", accessToken);
  //     } else {
  //         formData.append("username", email);
  //         formData.append("password", Buffer.from(password).toString('Base64'));
  //     }
  //
  //     return formData
  // };

  const onFinishFailed = errorInfo => {
  };

  const loginSuccess = () => {
    // for future...
  }
  const onFinish = values => {
    const {email, password, rememberMe} = values;

    if (rememberMe) {
      localStorage.setItem("rememberMe", email);
    } else {
      localStorage.removeItem("rememberMe");
    }
    let fcmToken = localStorage.getItem('fcm_token');
    if (!fcmToken) {
      fcmToken = deviceUUID.current;
    }
    // console.log('🟠-2-FCM TOKEN:', fcmToken);

    // const data = {
    //   grant_type: "password",
    //   client_id: process.env.NEXT_PUBLIC_CLIENT_ID,
    //   client_secret:process.env.NEXT_PUBLIC_CLIENT_SECRET,
    // };
    // const formData = new FormData();
    // Object.entries(data).forEach(([key, value]) => {
    //   formData.append(key, value);
    // });

    // formData.append("username", email);
    // formData.append("password", Buffer.from(password).toString('Base64'));

    // console.log("onFinish", email, password)

    dispatch(setInitUrl(""));
    userLogin(getLoginFormData({
        email: email,
        password: password,
        device_uuid: fcmToken,
      }),
      (data) => {
        // ✅ 첫 로그인 체크 (우선순위 최상위)
        if (data.is_first === true) {
          // 첫 로그인: 비밀번호 변경 모달 표시
          setCurrentLoginEmail(email);
          setCurrentLoginPassword(password);
          setFirstLoginUserId(data.id);
          setOpenFirstLoginModal(true);
        } else if (data.access_token) {
          // ✅SUCCESS - 정상 로그인
          loginSuccess();
        } else if (data.need_to_allow_device) {
          // 🟢20250730 - 새로운 기기 에러 처리
          // console.log('▶️', data);
          accessModeInfo.current = data;
          setOpenRegisterDevicePopup(true);
        }
      },
      (ret) => {
        errorCatchPopup(
          ret.response.data,
          () => { }
        );
    });
  };

  const handleRequestRegisterDevice = (values) => {
    requestRegisterData.current = values;
    setOpenRegisterDevicePopup(false);
    setLoadingMessage({
      title: intl.formatMessage({id: 'vlink.login.device.requestingHostApproval.title'}),
      message: intl.formatMessage({id: 'vlink.login.device.requestingHostApproval.message'}),
    });

    registerCancel.current = false;
    setDisableWaitingCancel(false);
    setTimeout(() => {
      setOpenWaitingRegisterPopup(true);
    }, 50);
    setTimeout(() => {
      if (!registerCancel.current) {
        setDisableWaitingCancel(true);
        userLoginByQuickLink(requestRegisterData.current, (data) => {
          // console.log('🔴:', JSON.stringify(data, null, 2));
          setOpenWaitingRegisterPopup(false);
          if (!registerCancel.current) {
            if (data.access_mode) {
              accessModeInfo.current = data;
              setTimeout(() => {
                setOpenRegisterDevicePopup(true);
              }, 50)
            }
          }
        });
      }
    }, 3000);
  };

  const handleRegisterDevice = (values) => {
    registerCancel.current = false;
    setDisableWaitingCancel(false);
    setLoadingMessage({
      title: intl.formatMessage({id: 'vlink.login.device.registeringTrustedDevice.title'}),
      message: intl.formatMessage({id: 'vlink.login.device.registeringTrustedDevice.message'}),
    })
    setTimeout(() => {
      setOpenWaitingRegisterPopup(true);
    }, 50);
    setTimeout(() => {
      if (!registerCancel.current) {
        setDisableWaitingCancel(true);
        userLoginByQuickLink(values, (data) => {
          if (!registerCancel.current) {
            // 🟢20250730 - 새로운 기기 에러 처리.
            if (data.access_token) {
              // ✅SUCCESS
              // 화면 세로 가운데(top: 50%)에 출력
              // message.config({
              //   top: '50%',  // px나 % 사용 가능
              //   // duration: 2, // 2초 후 사라짐 (기본 3초)
              // });
              message.success({
                content: intl.formatMessage({id: 'vlink.login.device.trustedDeviceRegistered'}),
                icon: <ToastSuccess/>,
              });
              loginSuccess();
            } else {
              // console.log('❌', 'handleRegisterDevice Failed');
            }
          }
        });
      }
    }, 3000);
  };

  // ✅ 첫 로그인 비밀번호 변경 처리
  const handleFirstLoginPasswordChange = async (newPassword) => {
    setIsChangingPassword(true);

    try {
      // 1. 비밀번호 변경 API 호출
      await beApis.changePasswordForFirstLogin(
        csSelected.host,
        firstLoginUserId,
        {
          password: Buffer.from(currentLoginPassword).toString('Base64'),
          new_password: Buffer.from(newPassword).toString('Base64'),
          re_new_password: Buffer.from(newPassword).toString('Base64'),
        }
      );

      // 2. 비밀번호 변경 성공: 모달 닫기
      setOpenFirstLoginModal(false);

      // 3. 새 비밀번호로 자동 재로그인
      let fcmToken = localStorage.getItem('fcm_token');
      if (!fcmToken) {
        fcmToken = deviceUUID.current;
      }

      userLogin(
        getLoginFormData({
          email: currentLoginEmail,
          password: newPassword,
          device_uuid: fcmToken,
        }),
        (data) => {
          console.log('🔵 [첫 로그인] 비밀번호 변경 후 재로그인 응답:', JSON.stringify(data, null, 2));

          // ✅ 디바이스 등록 체크 (우선순위 최상위)
          if (data.need_to_allow_device) {
            // 신규 디바이스 등록 프로세스로 진행
            console.log('🟢 [첫 로그인] 신규 디바이스 등록 모달 표시');
            accessModeInfo.current = data;
            setOpenRegisterDevicePopup(true);
          } else if (data.access_token) {
            // 성공 메시지 표시
            message.success({
              content: intl.formatMessage({id: 'vlink.firstLogin.success'}),
              icon: <ToastSuccess />,
            });
            // 정상 로그인 완료
            console.log('🟢 [첫 로그인] 정상 로그인 완료');
            loginSuccess();
          } else {
            console.log('🔴 [첫 로그인] access_token도 없고 need_to_allow_device도 없음:', data);
          }
        },
        (error) => {
          errorCatchPopup(error.response?.data, () => {});
        }
      );
    } catch (error) {
      // 비밀번호 변경 실패
      errorCatchPopup(
        error.response?.data || {
          message: 'vlink.firstLogin.error',
          code: 'CHANGE_PASSWORD_FAILED'
        },
        () => {}
      );
    } finally {
      setIsChangingPassword(false);
    }
  };

  const handleFirstLoginCancel = () => {
    setOpenFirstLoginModal(false);
    // 민감한 정보 초기화
    setCurrentLoginEmail('');
    setCurrentLoginPassword('');
    setFirstLoginUserId(null);
  };

  const checkApproval = (values) => {
    userLoginByApproval(values, (data) => {
      // console.log('🕙:', JSON.stringify(data, null, 2));
      // 🟢20250730 - 새로운 기기 에러 처리.
      if (data.access_token) {
        setOpenRegisterDevicePopup(false);
        // message.config({
        //   top: '50%',  // px나 % 사용 가능
        //   // duration: 2, // 2초 후 사라짐 (기본 3초)
        // });
        message.success({
          content: intl.formatMessage({id: 'vlink.login.device.trustedDeviceRegistered'}),
          icon: <ToastSuccess />,
        });
        loginSuccess();
      } else {
        // console.log('❌', 'handleRegisterDevice Failed', approvalCheckHandlerRef.current);
        if (data.pending?.status === 'denied') {
          setOpenRegisterDevicePopup(false);

          setTimeout(() => {
            errorPopup(
              intl.formatMessage({id: 'vlink.login.device.rejected'}),
              () => { })
          }, 100);
        } else {
          if (approvalCheckHandlerRef.current) {
            clearTimeout(approvalCheckHandlerRef.current);
          }
          approvalCheckHandlerRef.current = setTimeout(() => {
            checkApproval(values);
          }, 30000);
        }
      }
    });
  };

  if (SNSAccessToken) {
    return null
  }

  return (
    <div className="gx-app-login-wrap">
      <div className="gx-app-login-container">
        <div className="gx-app-login-main-content" style={{display: 'flex', flexDirection: 'column',alignItems: 'center', height: 678}}>
          <div className="gx-app-logo-content" style={{justifyContent: 'center', width: "60%"}}>
            <div className="gx-app-logo">
              <Logo/>
            </div>
          </div>
          <div className="gx-app-login-content" style={{width: "60%"}}>
            <Form
              form={form}
              // initialValues={{rememberMe: true}}
              name="basic"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className="gx-signin-form gx-form-row0"
              style={{marginBottom: 7}}
            >

              <Form.Item
                initialValue=""
                rules={[{required: true, message: 'The input is not valid E-mail!'}]} name="email">
                <Input
                  style={{
                    height: 44,
                    fontSize: 16,
                  }}
                  placeholder={intl.formatMessage({id: 'vlink.common.email'})}
                />
              </Form.Item>
              <div style={{
                flex: 1,
                width: '100%',
                height: 16,
              }}></div>
              <Form.Item
                initialValue=""
                rules={[{required: true, message: 'Please input your Password!'}]} name="password">
                <Input
                  style={{
                    height: 44,
                    fontSize: 16,
                  }}
                  type="password" placeholder={intl.formatMessage({id: 'vlink.common.password'})}/>
              </Form.Item>
              <Space className={'login-features'}>
                <Form.Item className={'remember-checked'} valuePropName="checked" name={"rememberMe"}
                           style={{marginBottom: 0}}>
                  <Checkbox>
                    <IntlMessages id="app.userAuth.rememberMe"/>
                  </Checkbox>
                </Form.Item>
                <Space align={'end'}>
                  <a href="/user/forgot-password/" className="gx-login-form-forgot gx-link">
                    <IntlMessages id="app.userAuth.forgotPassword"/>
                  </a>
                  {/*<Divider type={'vertical'}/>*/}
                  {/*<a href="/signup" className="gx-login-form-forgot gx-link">*/}
                  {/*  <IntlMessages id="app.userAuth.signUp"/>*/}
                  {/*</a>*/}
                </Space>
              </Space>
              <Form.Item className={'signin-button'}>
                <Button type="primary" className="gx-mb-0" htmlType="submit"
                        disabled={isLoading}
                        style={{
                          height: 46,
                          width: '100%',
                          borderRadius: 4,
                          backgroundColor: '#DF043A',
                          fontSize: 18,
                          fontWeight: 700,
                        }}>

                  {!isLoading ? <IntlMessages id="app.userAuth.signIn"/> : <CircularProgress2 />}
                </Button>
              </Form.Item>
              <Form.Item >
                <Button type="link"
                        style={{
                          width: '100%',
                          color: '#7E7E7E',
                        }}
                        onClick={() => navigate('/user/signup/')}
                        >
                  <IntlMessages id="app.userAuth.signUp"/>
                </Button>
              </Form.Item>
              {/*<Row style={{borderBottom: '1px solid #5e5e5e'}}/>*/}
              {/* <span
                className="gx-text-light gx-fs-sm"> demo user email: 'demo@example.com' and password: 'demo#123'</span> */}
            </Form>
          </div>
          {/*{isLoading &&*/}
          {/*  <div className="gx-loader-view">*/}
          {/*    <CircularProgress3 />*/}
          {/*  </div>}*/}
        </div>
      </div>
      {/* 신규 디바이스 등록 팝업 */}
      <AtomicPopup
        title={<IntlMessages id="vlink.page.signIn.loginFromNewDevice" />}
        titleStyle={{fontSize: 18}}
        headerStyle={{ marginBottom: 0}}
        bodyStyle={{ padding: '0' }}
        // title={<IntlMessages id="home.pc.add.selectNewPC" />}
        open={openRegisterDevicePopup}
        destroyOnClose={true}
        onOk={() => {
          setOpenRegisterDevicePopup(false)
        }}
        onCancel={() => {
          setOpenRegisterDevicePopup(false)
        }}
        centered
        footer={<div style={{
          height: 1,
        }}></div>}
        maskClosable={false}
        width={540}
      >
        <RegisterDevice
          deviceInfo={accessModeInfo.current}
          onOk={(data) => {
            if (data.is_requested) {
              handleRequestRegisterDevice(data);
            } else {
              setOpenRegisterDevicePopup(false)
              handleRegisterDevice(data);
            }
          }}
          onCancel={() => {
            setOpenRegisterDevicePopup(false)
            // 화면 세로 가운데(top: 50%)에 출력
            // message.config({
            //   top: '50%',  // px나 % 사용 가능
            //   duration: 2, // 2초 후 사라짐 (기본 3초)
            // });
            message.warning({
              content: intl.formatMessage({id: 'vlink.login.device.deviceUnregistered'}),
              icon: <ToastWarn />,
            });
          }}
          onClose={() => {
            setOpenRegisterDevicePopup(false)
          }}
          checkApproval={checkApproval}
          clearCheckApproval={() => {
            if (approvalCheckHandlerRef.current) {
              clearTimeout(approvalCheckHandlerRef.current);
            }
          }}
        />
      </AtomicPopup>

      <AtomicPopup
        // title={<IntlMessages id="vlink.page.signIn.loginFromNewDevice" />}
        // titleStyle={{fontSize: 18}}
        // headerStyle={{ marginBottom: 0}}
        bodyStyle={{
          padding: '0',
          borderRadius: 4,
        }}
        // title={<IntlMessages id="home.pc.add.selectNewPC" />}
        open={openWaitingRegisterPopup}
        destroyOnClose={true}
        onOk={() => {
          setOpenWaitingRegisterPopup(false)
        }}
        onCancel={() => {
          setOpenWaitingRegisterPopup(false)
        }}
        centered
        footer={<div style={{
          height: 0,
        }}></div>}
        maskClosable={false}
        closable={false}
        width={460}
      >
        <WaitingRegister
          title={loadingMessage.title}
          message={loadingMessage.message}
          disabled={disableWaitingCancel}
          onCancel={() => {
            registerCancel.current = true;
            setOpenWaitingRegisterPopup(false);
            // 화면 세로 가운데(top: 50%)에 출력
            // message.config({
            //   top: '50%',  // px나 % 사용 가능
            //   duration: 1, // 2초 후 사라짐 (기본 3초)
            // });
            message.warning({
              content: intl.formatMessage({id: 'vlink.login.device.deviceUnregistered'}),
              icon: <ToastWarn />,
            });
          }}
        />
      </AtomicPopup>

      {/* ✅ 첫 로그인 비밀번호 변경 모달 */}
      <FirstLoginPasswordModal
        open={openFirstLoginModal}
        onOk={handleFirstLoginPasswordChange}
        onCancel={handleFirstLoginCancel}
        isLoading={isChangingPassword}
      />
    </div>
  );
};

export default SignIn;
